import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useDialogStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      flex: 1,
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
      },
    },
    scrollPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
    },
    dialogTitle: {
      width: "90%",
    },
  }),
);
